import { showVideoModal } from '../util/modal-helpers';

class ModalPopup {
	constructor(el) {
		this.el = el;

		this.initializeModals();
	}

	initializeModals = () => {
		const btnModalVideo = this.el;

		if (btnModalVideo) {
			btnModalVideo.addEventListener('click', (e) => {
				const videoURL = e.currentTarget.getAttribute('data-video-url');

				showVideoModal(videoURL);
			});
		}
	};
}

export default ModalPopup;
